import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

const bodyText = css`
  font-family: var(${typography.body.fontFamily});
  font-weight: var(${typography.body.fontWeight});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  color: var(${colors.content.default});
`;

/*
  Labels take the free space and amounts size to their content, so every amount
  lines up on the right edge whatever its width. The rows are laid out by the
  grid alone: no row places itself by column index, so adding one is just a
  matter of rendering another label/amount pair.
*/
const row = css`
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: var(${spacing.sm});
  row-gap: var(${spacing.xs});
`;

export const priceBreakdown = row;

export const priceLabel = css`
  ${bodyText};
  margin: 0;
`;

export const priceAmount = css`
  ${bodyText};
  margin: 0;
  display: flex;
  align-items: center;
  justify-self: end;
`;

export const optionsBreakdown = css`
  ${row};
  grid-column: 1 / -1;
`;

export const optionsBreakdownCopy = css`
  ${priceLabel};
  grid-column: 1 / -1;
`;

/* Indented under the options heading, while its amount stays on the right edge. */
export const optionAmountLabel = css`
  ${priceLabel};
  padding-left: var(${spacing.md});
`;

export const priceAmountMinusSymbol = css`
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
`;

export const priceAmountPlusSymbol = css`
  ${/* Double ampersand selector to increase specificity and override existing styles */ ''}
  && {
    font-family: var(${typography.heading.fontFamily});
    font-size: var(${typography.heading.sizes.sm.fontSize});
    line-height: var(${typography.heading.sizes.sm.lineHeight});
  }
`;

/*
  The theme exposes a body weight and a heading weight with no semibold between
  them, so the total cannot be set apart by weight the way it used to be. It uses
  the heading face a size up instead, which is how ProductPrice treats the
  headline price. The size step is doing most of the work: the heading face alone,
  at body size, reads as a different voice rather than a louder one.
*/
const totalText = css`
  font-family: var(${typography.heading.fontFamily});
  font-weight: var(${typography.heading.fontWeight});
  font-size: var(${typography.heading.sizes.xs.fontSize});
  line-height: var(${typography.heading.sizes.xs.lineHeight});
`;

export const totalLabel = css`
  ${priceLabel};
  ${totalText};
`;

export const totalPrice = css`
  ${priceAmount};
  ${totalText};
`;
